<template>
  <div class="content">
    <div
      id="alert-within-page"
      class="alert alert-danger"
      v-if="organizationAllowedToRecord == false"
    >
      <span
        >You do not have an active recording subscription.
        <a :href="helpLinks.liveswitch.contact.link" target="_blank">
          Contact sales</a
        >
        to get access.</span
      >
    </div>
    <recording-storage-notif/>
    <recording-search-filter
      @searchTriggered="searchTriggered"
    ></recording-search-filter>
    <recording-search-result
      ref="RecordingSearchResult"
      @changeSort="updateSort($event)"
      @searchRetriggered="searchRetriggered"
      :searched="searched"
      :recordings="recordings"
      :recordingCount="recordingCount"
    ></recording-search-result>
  </div>
</template>

<script>
import RecordingSearchFilter from "@/pages/Recordings/RecordingSearchFilter";
import RecordingSearchResult from "@/pages/Recordings/RecordingSearchResult";
import RecordingStorageNotif from "@/pages/Recordings/RecordingStorageNotif";
import helpLinks from "../../contextualHelpLinks.js";
import api from "@/api";
const moment = require("moment");

export default {
  components: {
    RecordingSearchFilter,
    RecordingSearchResult,
    RecordingStorageNotif
  },
  data: () => ({
    searched: false,
    recordings: [],
    recordingCount: 0,
    sort: {
      page: 1,
      descending: true,
      rowsPerPage: 5,
      totalItems: null,
      sortBy: "startTimestamp"
    },
    filter: {
      appId: null,
      channelId: null,
      minDate: null,
      minTime: null,
      maxDate: null,
      maxTime: null,
      muxOnly: false
    },
    helpLinks: helpLinks,
    organizationAllowedToRecord: true,
  }),
  methods: {
    updateSort(newSort) {
      this.sort = newSort;
      if (this.searched) this.doSearch(this.filter, false);
    },
    //combine input date and time into a dateTime fit for the api service
    makeDateTime(date, time, isEndStamp) {
      if (date && time) {
        const dateString = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
        let dateTime = moment(`${dateString} ${time}`, "YYYY-MM-DD HH:mm");
        if (isEndStamp) {
          //When start and end search have same minute,
          //ensures api returns all recordings within that minute
          dateTime.endOf("minute");
        }
        return dateTime.toDate();
      } else if (date && !time) {
        //if only given date, set start time to start of day
        let dateTime = null;
        if (typeof date == "string") {
          dateTime = moment(date, "YYYY-MM-DD");
        } else {
          dateTime = moment(date);
        }
        dateTime = dateTime.startOf("day");
        if (isEndStamp) {
          //set end time to end of day
          dateTime = dateTime.endOf("day");
        }
        return dateTime.toDate();
      } else if (!date && time) {
        //if only given time, set date to today
        const dateString = moment().format("YYYY-MM-DD");
        let dateTime = moment(`${dateString} ${time}`, "YYYY-MM-DD HH:mm");
        return dateTime.toDate();
      } else {
        return null;
      }
    },
    searchTriggered(unsearchedFilter) {
      Object.assign(this.filter, unsearchedFilter);
      this.doSearch(this.filter, true);
    },
    searchRetriggered() {
      this.doSearch(this.filter, false);
    },
    resetRecordingResultPagination() {
      this.$refs.RecordingSearchResult.resetPagination();
    },
    wantMuxedOrAll(muxOnly) {
      //if ready is set to false, The Gateway can return only recordings wiith mux pending / mux not enabled.
      //We never want that result displayed in the cloud console, so instead null is passed to return all recordings
      if (muxOnly == true) {
        return true;
      }
      return null;
    },
    doSearch(filter, isNewSearch) {
      let me = this;
      api
        .getChannelRecordings(
          filter.appId,
          filter.channelId,
          this.makeDateTime(filter.maxDate, filter.maxTime, true),
          this.makeDateTime(filter.minDate, filter.minTime, false),
          this.wantMuxedOrAll(filter.muxOnly),
          [
            { k: "$count", v: true },
            {
              k: "$skip",
              v: this.toSkip(this.sort.page, this.sort.rowsPerPage)
            },
            { k: "$top", v: this.sort.rowsPerPage }
          ]
        )
        .then(result => {
          me.recordings = result[0].value;
          if (me.recordings) {
            me.recordings = me.recordings.sort((a, b) => new Date(b.startTimestamp) - new Date(a.startTimestamp));
          }
          me.recordingCount = result[1].count;
          me.searched = true;
          if (isNewSearch) me.resetRecordingResultPagination();
        })
        .catch(ex => {
          if (ex.code != 503) {
            console.error(
              "Encountered an unexpected error while loading your recordings.",
              ex
            );
            this.$store.commit(
              "pushError",
              "Encountered an unexpected error while loading your recordings."
            );
          }
          //no recordings found
          me.recordings = [];
          me.recordingCount = 0;
          me.searched = true;
          if (isNewSearch) me.resetRecordingResultPagination();
        });
    },
    toSkip(page, rowsPerPage) {
      return (page - 1) * rowsPerPage;
    }
  },
  created() {
    this.$store
      .dispatch("subscription/loadSubscription", localStorage.subscriptionId)
      .then(result => {
        this.organizationAllowedToRecord = result.enabledFeatures.includes(
          "recording"
        );
      });
  }
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/fm/colours";

#alert-within-page > span > a,
#alert-within-page > span > a:focus,
#alert-within-page > span > a:hover {
  color: white !important;
  text-decoration: underline !important;
}

#alert-within-page {
  z-index: 2 !important;
}
</style>
